import React, {Fragment,useState} from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { FaEyeSlash,FaEye,FaRegWindowClose,FaLock } from "react-icons/fa";
import axios from 'axios';

export const ModalContacto = (props) => {
    const history = useHistory();
    const location = useLocation();
    const recaptchaRef = React.createRef();
    const [aceptCaptha, setAceptCaptha] = useState(false);
    const onChange = (value) => {
        setAceptCaptha(true)
    }


    const [messageLogin, setmessageLogin] = useState('');
    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const [formIsInvalid, setformIsInvalid] = useState(false);
    const formIsInvalidChange = (val) => {
        setformIsInvalid(val)
    }

    
    const [asuntoData, setAsuntoData] = useState(null);
    const asuntoChange = (val) => {
        setAsuntoData(val.target.value)
    }

    const [mensajeData, setMensajeData] = useState(null);
    const mensajeChange = (val) => {
        setMensajeData(val.target.value)
    }
    
    const limpiaformularios = () => {
        asuntoChange('')
        mensajeChange('')
        document.getElementById('asunto').value = ''
        document.getElementById('mensaje').value = ''
        setformIsInvalid(false)
        setmessageLogin('')
    }

    const enviarMail = async () => {
        try {
            var dataForm = {
                "idCliente": props.idCliente,
                "IdUsuario": localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`),
                "emailRemitente": props.destinatario,
                "nombre":localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`),
                "email":localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-email`),
                "asunto": asuntoData,
                "mensaje": mensajeData,
                
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
              };
              console.log('dataForm',dataForm)
            await axios.post(`${process.env.REACT_APP_URL_API}formatos/EnviarFormularioContacto`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('No se ha podido enviar el email.')
                    }else{
                       
                        props.setmodalContacto(false)
                        formIsInvalidChange(false)
                        //limpiaformularios()
                  
                        
                    }
                }else{
                    messageLoginChange('No se ha podido enviar el email.')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            console.log("Error",error)
            messageLoginChange('No se ha podido enviar el email.') 
           // formIsInvalidChange(true)
        }
    }



   
    return  (
        <Fragment>
            <div className='Modal' onClick={(e) => { e.stopPropagation() ;  props.setmodalContacto(false)} }>
                <div className='ContentModal' onClick={(e) => { e.stopPropagation() } }>
                    <div className='bodyModal'>
                        <div className="container">
                        <div className="row">
                            <div className="col-md-12 ">
                                <h1 class="titulostand">Contacto</h1>
                                <div className="">
                                    <div>{messageLogin}</div>
                                    <form className="form" onSubmit={(e) =>{ e.preventDefault(); enviarMail()}}>
                                        <div className="form-group mb-12 mr-sm-12">
                                            <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="asunto" name="asunto" placeholder="Asunto" required  onChange={ asuntoChange } /><br/>
                                        </div>
                                        <div className="form-group mb-12 mr-sm-12">
                                        <label for="mensaje">Mensaje:</label>
                                        <textarea className={formIsInvalid ? 'form-control is-invalid' : 'form-control'} id="mensaje" name="mensaje" rows="3" placeholder="Mensaje*"  required  onChange={ mensajeChange }></textarea><br/>
                                        </div>
                                       
                                        <div className="form-group mb-12 mr-sm-12">
                                            <div class="form-check-row">
                                                <input type="checkbox" className="politica" id="politica" required />
                                                <label class="form-check-label" for="exampleCheck1">Acepto la <a href="https://laneurona.com/terminos-y-condiciones/" target="_blank" to="/politicadeprivacidad" >Política de Privacidad</a></label>
                                            </div>
                                        </div>
                                        <div className="captcha">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6Lfso_4ZAAAAACvxcgENu4ZlutKf3CfJy1z7pkrh"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <br/>
                                        <div className="form-group">
                                            <button className="btn btn-danger btn-form" type="submit" disabled={!aceptCaptha} >Enviar</button>
                                        </div>
                                    </form> 
                                </div>
                            </div>
                        </div>
                        </div>
                    </div> 
                </div>
            </div>
        </Fragment> 
    )
    
}